import { render, staticRenderFns } from "./AIWorkAchievementsCoach.vue?vue&type=template&id=0f6b8e08&scoped=true"
import script from "./AIWorkAchievementsCoach.vue?vue&type=script&lang=js"
export * from "./AIWorkAchievementsCoach.vue?vue&type=script&lang=js"
import style0 from "./AIWorkAchievementsCoach.vue?vue&type=style&index=0&id=0f6b8e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b8e08",
  null
  
)

export default component.exports